<template>
  <div class="mpm_upload_img">
    <!--    <div class="">-->
    <!--      <div class="list-picture-card-container" v-if="url">-->
    <!--        <span>-->
    <!--          <div class="upload_card">-->
    <!--            <div class="ant-upload-list-item-info">-->
    <!--              <span>-->
    <!--                <video-->
    <!--                  :src="url"-->
    <!--                  controls="controls"-->
    <!--                  initial-time="0"-->
    <!--                  loop="false"-->
    <!--                  muted="false"-->
    <!--                  direction="0"-->
    <!--                  style="max-width: 100%; min-width: 300px; max-height: 300px"-->
    <!--                ></video>-->
    <!--              </span>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </span>-->
    <!--      </div>-->
    <!--    </div>-->
    <a-spin :spinning="spinning">
      <div class="table-cell_upload upload_card">
        <input type="file" :accept="currentAccept" ref="fileDom" style="display: none" @change="getFile" />
        <span class="table-cell_upload_1" v-if="!url" @click="uploadFile">
          <div>
            <a-icon type="plus" />
            <div class="ant-upload-text">上传</div>
          </div>
        </span>
        <div class="video_block" v-if="url">
          <video
            :src="url"
            initial-time="0"
            loop="false"
            muted="false"
            direction="0"
            style="max-width: 100%; min-width: 150px; max-height: 240px"
          ></video>
          <div class="upload-list-item-actions">
            <a-icon type="eye" @click.stop="handlePreview" />
            <a-icon type="delete" @click.stop="handleRemove" />
          </div>
        </div>
      </div>
      <div v-if="url">视频地址: {{ url }}</div>

      <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
        <div class="modal_video">
          <video
            :src="url"
            controls="controls"
            initial-time="0"
            loop="false"
            muted="false"
            direction="0"
            style="max-width: 100%; min-width: 150px; max-height: 40vh"
          ></video>
        </div>
      </a-modal>
    </a-spin>
  </div>
</template>
<script>
  import dayjs from 'dayjs'
  import { UPLOAD_CDN_HOST } from '@/config/env'
  import client from '@/config/alioss'

  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = (error) => reject(error)
    })
  }

  const accept = {
    video: 'video/*,audio/*',
  }

  export default {
    model: {
      prop: 'value',
    },
    props: {
      accept: {
        type: String,
        default: 'video',
      },
      url: String,
    },
    created() {},
    data() {
      return {
        currentAccept: accept[this.accept],
        previewVisible: false,
        previewImage: '',
        client: client,
        beforeUploadCheck: true,
        spinning: false,
        baseUrl: UPLOAD_CDN_HOST[process.env.VUE_APP_SERVER_ENV],
      }
    },
    methods: {
      /**
       * 上传文件事件
       **/
      uploadFile() {
        this.$refs.fileDom.dispatchEvent(new MouseEvent('click'))
      },
      /**
       * 上传文件
       **/
      getFile(event) {
        const file = this.$refs.fileDom.files[0]
        if (!this.beforeUpload(file)) {
          return
        }
        // console.log(file)
        this.putObject(file)
      },
      /**
       * 预览
       **/
      handlePreview() {
        this.previewVisible = true
      },
      /**
       * 关闭预览事件
       **/
      handleCancel() {
        this.previewVisible = false
      },

      /**
       * 上传前校验
       **/
      beforeUpload(file) {
        this.beforeUploadCheck = true
        const isVideo = file.type.indexOf('audio') > -1 || file.type.indexOf('video') > -1
        if (!isVideo) {
          this.$message.error('只能上传视频或音频')
        }
        const isLt1000M = file.size / 1024 / 1024 <= 1000
        if (!isLt1000M) {
          this.$message.error('最大只能上传1000MB!')
        }

        this.beforeUploadCheck = isVideo && isLt1000M
        return isVideo && isLt1000M
      },
      /**
       * 文件上传方法
       * @param data file文件
       * @returns {Promise<void>}
       */
      async putObject(file) {
        try {
          this.spinning = true
          // object-key可以自定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至当前Bucket或Bucket下的指定目录。
          const key = 'yeb/pc/' + dayjs().format('YYYY-MM-DD') + '/' + this.$utils.uuid()
          // console.log('上传开始 %s', key)
          // console.log(client)
          let result = await client.put(key, file)
          // console.log(result)
          // console.log(file)
          this.spinning = false
          if (result.res.statusCode === 200) {
            // 返回正确的结果
            this.$emit('update:url', result.url)
            this.$emit('cbFile', result)
          }
          this.$refs.fileDom.value = ''
        } catch (e) {
          this.spinning = false
          console.error('file error %o', e)
          this.$refs.fileDom.value = ''

          this.handleRemove(file)
        }
      },
      /**
       * 删除
       **/
      handleRemove(file) {
        // 返回正确的结果
        this.$emit('update:url', '')
        this.$emit('cbFile', {})
      },
    },
    watch: {
      // url(newValue, oldValue) {
      //   this.filterFile()
      // },
      // urls(newValue, oldValue) {
      //   this.filterFile()
      // },
      // fileList(newValue, oldValue) {
      //   // let newValueName = this.$utils.getKeyForList(newValue, 'name')
      //   // let oldValueName = this.$utils.getKeyForList(oldValue, 'name')
      //   // if (this.$utils.equals(newValueName, oldValueName)) return
      //   // console.log(newValue)
      //   // console.log(oldValue)
      //   // this.$emit('cb', this.fileList)
      //   // this.$emit('cbUrls', this.backImages())
      // },
    },
  }
</script>
<style lang="scss" scoped>
  .mpm_upload_img {
    line-height: 1.5;

    .list-picture-card-container {
      /*float: left;*/
      /*width: 104px;*/
      /*height: 104px;*/
      /*margin: 0 8px 8px 0;*/
    }

    .upload-list-item-actions {
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 10;
      white-space: nowrap;
      transform: translate(-50%, -50%);
      opacity: 0;
      transition: all 0.3s;
    }

    .table-cell_upload,
    .table-cell_upload_1 {
      display: table-cell;
      width: 100%;
      height: 100%;
      padding: 8px;
      text-align: center;
      vertical-align: middle;
    }

    .video_block {
      position: relative;
    }

    .table-cell_upload:hover {
      .video_block::before {
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        transition: all 0.3s;
        content: ' ';
      }

      .upload-list-item-actions {
        opacity: 1;

        .anticon {
          font-size: 24px;
          margin-right: 12px;
        }
      }
    }

    .upload_card {
      display: table;
      width: 104px;
      height: 104px;
      margin-right: 8px;
      margin-bottom: 8px;
      text-align: center;
      vertical-align: top;
      background-color: #fafafa;
      border: 1px dashed #d9d9d9;
      border-radius: 4px;
      cursor: pointer;
      transition: border-color 0.3s ease;
    }

    .anticon {
      font-size: 32px;
      color: #999;
      display: inline-block;
      font-style: normal;
      line-height: 0;
      text-align: center;
      text-transform: none;
      vertical-align: -0.125em;
      text-rendering: optimizeLegibility;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
  }

  .modal_video {
    padding: 40px 10px 20px;
    text-align: center;
  }
</style>
